"use strict";

(function (H) {
	/**
	 * plotPrice
	 * plotOrder - bid/ask
	 * plot orderZone (binary options)
	 */

	var priceLabelOptions = {
		color: '',
		sufix: ''
	};

	/**
	 * Display price label, if exists -> update position
	 * @param  {object} options {val/pos: 1.234, color: '', sufix: '$'}
	 *
	 */
	H.Axis.prototype.priceLabel = function (options, symbol) {

		var axis = this;

		if (axis.isXAxis || typeof options == 'undefined' || typeof options.val == 'undefined') {
			return;
		}
		if (axis.price) {
			axis.price[0].update(options);
		} else {

			if(symbol != 'null:cur'){
				var plOptions = merge(priceLabelOptions, options);
				plOptions.chart = axis.chart;
				plOptions.axis = axis;
				plOptions.symbol = symbol;

				if(!axis.price){
					axis.price = [];
					axis.price.push(new Price(plOptions))
				}
				else{
					axis.price.push(new Price(plOptions))
				}
			}
		}
	};

	H.Axis.prototype.removePriceLabel = function () {
		if (this.price) {

			for (var i=0; i <this.price.length; i++){
				this.price[i].destroy();
			}
			delete this['price'];
		}
	};

	H.wrap(H.Axis.prototype, 'destroy', function (proceed, data) {

		if (this.price) {
			for (var i=0; i <this.price.length; i++){
				this.price[i].destroy();
			}
			delete this['price'];
		}

		proceed.apply(this, Array.prototype.slice.call(arguments, 1));
	}); /* on destroy -> free memory */



	H.wrap(H.Axis.prototype, 'redraw', function (proceed) {

		proceed.apply(this, Array.prototype.slice.call(arguments, 1));

		var orders = this.chart.orders || {};

		for (var key in orders) {

			orders[key].redraw();
		}
	});

	var Price = function Price() {
		this.init.apply(this, arguments);
		return this;
	};

	Price.prototype = {
		init: function init(userConfig) {

			var config = this.userConfig = userConfig,
			    chart = config.chart,
			    axis = config.axis;

			config.pos = axis.toPixels(config.val);

			/* set this label decimals */
			serieDbType = axis.series[0].userOptions.db_type;

			if (axis.series[0].options.nDecimals !== undefined && axis.series[0].options.nDecimals) this.nDecimals = axis.series[0].options.nDecimals;else {
				this.nDecimals = data_decimalsByType(serieDbType, axis.series[0].userOptions.id);
				if (this.nDecimals < 0) {
					this.nDecimals = 2;
				}
			}

			this.s = config.symbol;

			this.line = new PlotLine(userConfig);

			this.label = new PlotLabel({
				chart: chart,
				axis: axis,
				pos: config.pos,
				val: config.val,
				symbol:config.symbol,
				label: typeof this.nDecimals != 'undefined' ? Number(config.val).toFixed(this.nDecimals) : config.val,
				width: chart.chartWidth - chart.plotWidth - chart.plotLeft - axis.left,
				csAttr: {
					'right': '0px'
				}
			});
		},

		update: function update(options) {

			if(this.userConfig.chart.series[0].options.compare == 'percent'){
				this.userConfig.val = this.userConfig.chart.series[0].points[this.userConfig.chart.series[0].points.length-1].change
			}else if(this.userConfig.chart.series[0].options.compare == 'value'){
				this.userConfig.val = this.userConfig.chart.series[0].points[this.userConfig.chart.series[0].points.length-1].change
			}else{
				if (!options || !options.val) {
					return;
				}else{
				this.userConfig.val = typeof this.nDecimals != 'undefined' ? Number(options.val).toFixed(this.nDecimals) : options.val;
				}
			}
			this.redraw();
		},

		redraw: function redraw() {

			if (this.userConfig.axis.series[0]) {
				var mSeries = this.userConfig.axis.series[0];

				if (mSeries.options.id != this.s) {
					this.s = mSeries.options.id;
					if (mSeries.options.nDecimals != undefined) this.nDecimals = this.userConfig.axis.series[0].options.nDecimals;
				}
			}

			var config = this.userConfig,
				chart = config.chart,
				axis = config.axis,
				options = {
				val: config.val,
				pos: axis.toPixels(config.val),
				width: chart.chartWidth - chart.plotWidth - chart.plotLeft - axis.left
			};
			
					//CHECK FOR TYPE OF AXIS AND UPDATES THE CLOSE LINE AND CLOSE LABEL
					for (let i = 0; i < axis.series.length - 1; i++) {
						if (axis.chart.series[i] != undefined) {
							if (
								axis.chart.series[i].chart.series[i].userOptions.compare ==
									"percent" ||
								axis.chart.series[i].chart.series[i].userOptions.compare == "value"
							) {
								options.val =
									axis.series[i].data[axis.series[0].data.length - 1].change;
								options.pos = axis.toPixels(options.val);
							}
						}
					}

			if(this.line && this.label) {
				this.line.update(options);
				this.label.update(options);
			}
		},

		destroy: function destroy() {

			if(this.line && this.label) {
				this.line.destroy();
				this.label.destroy();
				delete this['line'];
				delete this['label'];
			}
		},

		reflow: function reflow() {
			this.destroy();
			this.init(this.userConfig);
		}

	};

	var defaultPlotLineCss = {
		'stroke-width': 1,
		zIndex: 10
	};

	var PlotLine = function PlotLine() {
		this.init.apply(this, arguments);
		return this;
	};

	PlotLine.prototype = {

		init: function init(userConfig) {

			var chart = userConfig.chart,
			    axis = userConfig.axis,
			    csAttr = merge(defaultPlotLineCss, userConfig.csAttr || {});

			csAttr.dashstyle = 'ShortDot';
			csAttr.class = 'closeLine'; //#428bca
			csAttr.id = 'closeLine-'+userConfig.symbol.split(":")[0];

			// for (var i = 0; i< all_serires.length;i++){
			// 	if(userConfig.symbol.toLowerCase()== all_serires[i].iids.toLowerCase()) {
			// 		csAttr.stroke = all_serires[i].color == null ? 'blue' : all_serires[i].color;
			// 	}
			// }

			var ioLineWidth;
			if(screen.width < 640){ ioLineWidth = 700 }else{ ioLineWidth = chart.plotLeft + screen.width + axis.left; }
			this.line = chart.renderer.path(['M', chart.plotLeft, 0, 'L', ioLineWidth, 0]).attr(csAttr).add().toFront();
			this.line.element.style.stroke = userConfig.chart.series[0].color;

			this.line.translate(0, userConfig.pos);
		},

		update: function update(options) {

			this.line.translate(0, options.pos);
		},

		destroy: function destroy() {
			this.line.destroy();
			return null;
		}
	};

	var defaultLabelCss = {
		position: 'absolute',
		'background-color': '#2962FF',
		'text-align': 'center',
		'color': '#FFFFFF',
		'font-size': regularFontSize,
		'padding': '2px',
		'padding-right': '4px',
	};

	var PlotLabel = function PlotLabel() {
		this.init.apply(this, arguments);
		return this;
	};

	PlotLabel.prototype = {
		offset: 11,

		init: function init(userConfig) {
			//ON INIT CREATES PLOTLABEL / CLOSING LABEL 
			var chart = this.chart = userConfig.chart;


			this.csAttr = merge(defaultLabelCss, userConfig.csAttr || {});

			if(isToChangeMarginsY == true){
				this.csAttr.width = '68px';
			}else{
				this.csAttr.width = '61px';
			}

			this.csAttr.width = '61px';
			this.csAttr['padding-top'] = '5px'
			this.csAttr['padding-right'] = '0'
			this.csAttr['padding-bottom'] = '4px'
			this.csAttr['padding-left'] = '0'
			this.csAttr['text-align'] = 'center'
			
			this.csAttr.backgroundColor = userConfig.chart.series[0].color;
			this.label = $('<div id="Label-'+userConfig.symbol.split(":")[0]+'" class="iChart-plotLabel"></div>').css(this.csAttr).html(this.setLabelDecimals(userConfig.label) || '');
			
			let lastPosition = userConfig.chart.series[0].data.length-1;

			if((userConfig.chart.series[0].data[lastPosition].close > userConfig.chart.series[0].data[lastPosition].open) && (userConfig.chart.prevType == 'candlestick' || userConfig.chart.prevType =='ohlc')){
				this.label[0].style.backgroundColor = "rgb(40, 166, 154)";
			}
			else{
			this.label[0].style.backgroundColor = userConfig.chart.series[0].color;
		}
			$(chart.container).append(this.label);
			this.label.css({ top: userConfig.pos - this.offset });

			if (userConfig.axis.userOptions.id == 'y_axis_2') {
				this.label.css({ left: 0, right: "" });
			}
		},

		setLabelDecimals: function (value) {
			var val = Number(parseFloat(value).toFixed(5))
			
			if(val > 0.00001 && val < 0.009){
				val = Number(parseFloat(value).toFixed(6))
			}
			if (val > 10) {
				val = parseFloat(val).toFixed(3)
			}
			if (val > 100) {
				val = parseFloat(val).toFixed(2)
			}
			if (val > 1000) {
				val = parseFloat(val).toFixed(1)
			}
			if (val > 10000) {
				val = parseFloat(val).toFixed(0)
			}
			return val;
		},

		update: function update(options) {

			this.label.html(this.setLabelDecimals(options.val))
				.css({ top: options.pos - this.offset });

			/*this.label.css({
				width: '61px',
			});*/
		},

		destroy: function destroy() {
			this.label.remove();
			return null;
		}
	};
})(Highcharts);